import type { AiAppCenterModule } from '../types'

/** 后端 system_module.name=ai；独立窗 app 经 resolveStandaloneAppKey 映射为 aiModel */
export const aiModelModule: AiAppCenterModule = {
  key: 'aiModel',
  label: 'AI大模型',
  desc: '对话 / 绘画 / 写作 / 音乐 / 思维导图 / 模型配置',
  path: '/ai',
  homePath: '/ai/chat',
  icon: 'ep:cpu',
  color: '#64748b',
  // 秘书已迁至 /ai-secretary 独立根；此处兜底隐藏历史菜单标题
  hiddenStandaloneMenuTitles: ['AI 数字员工', 'AI数字员工', 'AI超级小秘书'],
  aliases: [
    'AI 大模型', '大模型', 'AI对话', 'AI绘画',
    'AI写作', 'AI音乐', 'AI思维导图'
  ]
}
